import { createAction, props } from '@ngrx/store';

import type { Profile } from '../../models/profile';

export const loadUserProfile = createAction('[PermissionProfile] Load User Profile');
export const loadUserProfileSuccess = createAction(
  '[PermissionProfile] Load User Profile Success',
  props<{ profile: Profile }>()
);
export const loadUserProfileFailure = createAction(
  '[PermissionProfile] Load User Profile Failure',
  props<{ error: '' }>()
);
export const setUserProfile = createAction(
  '[PermissionProfile] Set User Profile',
  props<{ profile: Profile }>()
);
